// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"PhotonInput_inputContainer__WV89D"};